import { SessionContext } from "../context/SessionContext";
import React, { FunctionComponent, useContext } from "react";
import { Route, Redirect, RouteProps } from "react-router-dom";
import { routes } from "../routes";

const AdminRoute: FunctionComponent<RouteProps> = ({
  component: Component,
  path,
  ...restProps
}) => {
  const session = useContext(SessionContext);

  return (
    <Route
      {...restProps}
      path={path}
      render={props => {
        if (session.user == null)
          return <Redirect to={{ pathname: routes.login, state: { from: props.location } }} />

        return session.user.is_admin ? (
          <Component {...props} />
        ) : (
          <h2>Brak dostępu.</h2>
        );
      }}
    />
  );
};

export default AdminRoute;
